export const ACCEPT_COOKIES = 'ACCEPT_COOKIES';